import { useEffect } from 'react'
import { setSurfaceThemeOverride } from '../services/surfaceThemeOverride'
import { useClientPreferences } from '../context/useClientPreferences'

export const MemberSurfaceTheme = () => {
  const { preferences } = useClientPreferences()
  const theme = preferences.memberAppTheme

  useEffect(() => {
    setSurfaceThemeOverride(theme)
    return () => {
      setSurfaceThemeOverride(null)
    }
  }, [theme])

  return null
}
